module.exports = __webpack_public_path__ + "img/THEOS_LOGO_CHROME1.f94cb126.png";